import { connect } from 'react-redux';
import { SupportedLanguage } from '../../../../config/constants/supportedLanguage.enum';
import { IReduxRootState } from '../../../reduxRootState.interface';
import SupportLanguageHelper from '../../../../utils/SupportLanguageHelper';
import CountryField, { ICountryFieldOwnProps, ICountryFieldStateProps } from './CountryField';

const mapStateToProps = (state: IReduxRootState) => {
    const lang: SupportedLanguage = SupportLanguageHelper.getSupportLanguage(state.app.locale);

    return {
        countriesMap:
            state.app && state.countries.countriesMap ? state.countries.countriesMap[lang] : {},
    };
};

export const CountryFieldContainer = connect<
    ICountryFieldStateProps,
    any,
    ICountryFieldOwnProps,
    IReduxRootState
>(mapStateToProps)(CountryField);
